import { Reducer } from "redux";
import APIClient from "web_modules/APIClient";
import {
  LOAD_QUEUES_PENDING,
  LOAD_QUEUES_FAILURE,
  LOAD_QUEUES_SUCCESS,
  LOAD_TASKS_PENDING,
  LOAD_TASKS_FAILURE,
  LOAD_TASKS_SUCCESS,
  LOAD_LOAN_MANAGERS_SUCCESS,
  ADD_QUEUE_PENDING,
  ADD_QUEUE_FAILURE,
} from "./types";

// TODO kevin fix "any" type on apps
export interface QueuesState {
  apps: any;
  loading: boolean;
  error: string;
}

const initialState: QueuesState = {
  apps: null,
  loading: false,
  error: null,
};

// Reducer
const reducer: Reducer<QueuesState> = (state: QueuesState = initialState, action) => {
  const { type, payload, error } = action;

  switch (type) {
    case LOAD_QUEUES_PENDING:
    case LOAD_TASKS_PENDING:
    case ADD_QUEUE_PENDING:
      return {
        ...state,
        loading: true,
      };
    case LOAD_QUEUES_FAILURE:
    case LOAD_TASKS_FAILURE:
    case ADD_QUEUE_FAILURE:
      return {
        ...state,
        loading: false,
        error,
      };
    case LOAD_QUEUES_SUCCESS:
      return {
        ...state,
        loading: false,
        apps: payload.apps,
      };
    case LOAD_TASKS_SUCCESS:
      return {
        ...state,
        loading: false,
        tasks: payload.next_tasks,
      };
    case LOAD_LOAN_MANAGERS_SUCCESS:
      return {
        ...state,
        loading: false,
        loan_managers: payload.loan_managers,
      };
    default:
      return state;
  }
};

const loadAppsSuccess = tasking_fields => {
  return {
    type: LOAD_QUEUES_SUCCESS,
    payload: {
      apps: tasking_fields,
    },
  };
};

const loadTasksSuccess = next_tasks => {
  return {
    type: LOAD_TASKS_SUCCESS,
    payload: {
      next_tasks,
    },
  };
};

const loadLoanManagersSuccess = loan_managers => {
  return {
    type: LOAD_LOAN_MANAGERS_SUCCESS,
    payload: {
      loan_managers,
    },
  };
};

// Thunk
const loadApps = (dispatch: Function) => {
  return APIClient.get("/uw/tasking_fields").then((resp: any) => {
    dispatch(loadAppsSuccess(resp.tasking_fields));
  });
};

const loadTasks = (dispatch: Function) => {
  return APIClient.get("/uw/queues/next_tasks").then((resp: any) => {
    dispatch(loadTasksSuccess(resp.next_tasks));
  });
};

const loadLMs = (dispatch: Function) => {
  return APIClient.get("/uw/trus_operators").then((resp: any) => {
    dispatch(loadLoanManagersSuccess(resp.loan_managers));
  });
};

export { reducer as default, loadApps, loadTasks, loadLMs };
